import React, { useState } from "react"
import { CardText, Col, Row, Button } from "reactstrap"

import DPTextBox from "../../../framework/components/DPTextBox"
import DPTextBoxButton from "framework/components/DPTextBoxButton"
import DPSwitch from 'framework/components/DPSwitch'
import { Text, Numeric } from "../../../framework/validators/TextValidation"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"

const GroupMasterContent = ({

  Details,
  strGPTitle,
  modelOpen,
  modelTrigger,
  GetSelectRow,
  GroupNo,
  CodeValue,
  CodeLen,
  CodeDisable,
  CodeOnChange,
  DescValue,
  DescDisable,
  DescOnChange,
  CodeOnBlur,
  onButtonClick,
  btnDisable,
  SearchDisable,
  menuCode,
  autoCode
}) => {

  const ApiURL = window.Links.ApiURL
  const [Datatablesub, SetDatatablesub] = useState([])
  const [groupFilter, SetGroupFilter] = useState('a')

  const column = [
    {
      field: "GP_CODE",
      title: "Code",
      align: "center",
    },
    {
      field: "GP_DESC",
      title: "Description",
      align: "center",
    }
  ]


  async function tog_backdrop() {
    // let dt;
    // const authToken = localStorage.getItem("authToken")
    // const ApiURL = window.Links.ApiURL
    // await fetch(`${ApiURL}group/all/${GroupNo}`, {
    //   method: "GET",
    //   headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
    // })
    //   .then(Response => Response.json())
    //   .then(responseData => {
    //     SetDatatable(responseData.data)
    //     dt = responseData.data
    //   })
    // let i = 1;
    // dt.map((r) => {
    //   searchData = searchData.concat(TableDataBuilder(i, r))
    //   i++
    // });
    // //console.log(searchData)
    // SetDatatable(searchData);
    modelTrigger();
  }

  //modal props
  const columns = [{
    dataField: 'id',
    text: 'Id',
    sort: true,
  }, {
    dataField: 'code',
    text: 'Code',
    sort: true
  }, {
    dataField: 'name',
    text: 'Name',
    sort: true
  }];

  //default sorted method
  const defaultSorted = [{
    dataField: 'id',
    order: 'asc'
  }];



  return (
    <React.Fragment>
      <div>
        <Col sm="12">
          <CardText className="mb-0">
            <Row>
              <Col sm={12} md={6} className="mb-4-sm">
                {/*<DPDropDown
                  labelText="Group"
                  rowClass="mb-4-sm"
                  id={"txtType"}
                  optionGroup={typeGroup}
                  selectedGroup={strTypeVal}
                  onChange={SetTypeVal}
                  //isDisabled={false}
                  labelHide={false}
                />*/}
                <DPTextBoxButton
                  rowClass="mb-4-sm"
                  labelText="Code*"
                  textType="text"
                  maxLength={CodeLen}
                  value={CodeValue}
                  onChange={CodeOnChange}
                  onBlur={CodeOnBlur}
                  disabled={CodeDisable}
                  onButtonClick={onButtonClick}
                  btnDisable={CodeDisable == true ? true : btnDisable}
                  placeholder={autoCode}
                />
                <DPTextBox
                  rowClass="mb-4-sm"
                  labelText="Description*"
                  textType="text"
                  maxLength="40"
                  value={DescValue}
                  onChange={DescOnChange}
                  disabled={DescDisable}
                />
                {Details.map((dr) => (
                  <DCItem
                    ID={dr.dId}
                    type={dr.dtype}
                    name={dr.dname}
                    feildLenth={dr.feildLenth}
                    require={dr.req}
                    values={dr.value}
                    disabled={DescDisable}
                  />
                ))}
                {/*<Row>
                  <Col sm={3}>Active</Col>
                  <Col >
                    <DPSwitch
                      rowClass={"mb-4-sm"}
                    //onChange={SwonChange}
                    //checked={ActiveSw}
                    //disabled={disabled}
                    />
                  </Col>
                </Row>*/}
              </Col>
              <Col sm={12} md={6} className="mb-4-sm">
                <Button
                  onClick={() => {
                    tog_backdrop()
                  }}
                  color="success"
                  className="btn-sm"
                  disabled={SearchDisable}
                >
                  <i
                    className="mdi mdi-search-web"
                    style={{ fontSize: "12px" }}
                  ></i>
                </Button>
              </Col>
            </Row>
            {/* <DPSearchBox
              searchData={DataTables}
              columns={columns}
              defaultSorted={defaultSorted}
              mainTitle={`${strGPTitle} Search`}
              SelectType={'radio'}//checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
              isOpen={modelOpen}
              toggle={modelTrigger}
              getSelect={GetSelectRow}
            /> */}
            <DPSearchBoxDynamic
              searchData={Datatablesub}
              columns={column}
              defaultSorted={defaultSorted}
              mainTitle={`${strGPTitle} Search`}
              SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
              isOpen={modelOpen}
              toggle={modelTrigger}
              getSelect={GetSelectRow}
              APIURL={ApiURL}
              URLPath={"GRP"}
              MenuCode={menuCode}
              KeyVal={'GRP' + GroupNo}
              searchBy={'GP_CODE'}
              FilterStr={groupFilter}
            />
          </CardText>
        </Col>
      </div>
    </React.Fragment>
  )
}
export default GroupMasterContent

const DCItem = ({ type, name, feildLenth, require, ID, values, disabled }) => {
  const [strDet, SetDet] = useState(null)
  const [strSw, SetSw] = useState(null)
  //console.log(feildLenth)
  switch (type) {
    case '0': return (
      <DPTextBox
        id={"GP_FIELD" + ID}
        rowClass="mb-4-sm"
        labelText={name}
        textType="text"
        maxLength={feildLenth}
        value={strDet == null ? values : strDet}
        onChange={e => { SetDet(Text(e.target, feildLenth, true, false, "any", true)) }}
        disabled={disabled}
      />
      //Text(e.target,feildLenth,true,false,"any",true)
    );
      break;
    case '1': return (
      <DPTextBox
        id={"GP_FIELD" + ID}
        rowClass="mb-4-sm"
        labelText={name}
        textType="text"
        textAlign="right"
        maxLength={feildLenth}
        value={strDet == null ? values : strDet}
        onChange={e => { SetDet(Numeric(e.target, feildLenth, 0, false)) }}
        disabled={disabled}
      />
      //Numeric(e.target,feildLenth,0,false)
    );
      break;
    case '2': return (
      <DPTextBox
        id={"GP_FIELD" + ID}
        rowClass="mb-4-sm"
        labelText={name}
        textType="date"
        maxLength={feildLenth}
        value={strDet == null ? values : strDet}
        onChange={e => { SetDet(e.target.value) }}
        disabled={disabled}
      />
    );
      break;
    case '3':
      return (
        <Row>
          <Col sm={3}>{name}</Col>
          <Col >
            <DPSwitch
              id={"GP_FIELD" + ID}
              rowClass={"mb-4-sm"}
              onChange={e => { SetSw(!strSw) }}
              checked={strSw == null ? (values == "True" ? true : false) : strSw}
              disabled={disabled}
            //disabled={Disabled}
            />
          </Col>
        </Row>
      );
      break;
    default: return (<div></div>)
  }
}
